import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../config/axiosConfig';

export const fetchAllJournals = createAsyncThunk(
  'projectJournal/fetchAll',
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get("/projectJournal");
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const fetchCurrentStage = createAsyncThunk(
  'projectJournal/fetchCurrentStage',
  async ({ leadId, assignedPerson }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/projectJournal/${leadId}/${assignedPerson}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const moveToNextStage = createAsyncThunk(
  'projectJournal/moveToNextStage',
  async ({ leadId, assignedPerson }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(`/projectJournal/${leadId}/${assignedPerson}/next`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const projectJournalSlice = createSlice({
  name: 'projectJournal',
  initialState: {
    journals: [],
    currentStage: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(fetchAllJournals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllJournals.fulfilled, (state, action) => {
        state.journals = action.payload;
        state.loading = false;
      })
      .addCase(fetchAllJournals.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })

      .addCase(fetchCurrentStage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCurrentStage.fulfilled, (state, action) => {
        state.currentStage = action.payload;
        state.loading = false;
      })
      .addCase(fetchCurrentStage.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })

      .addCase(moveToNextStage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(moveToNextStage.fulfilled, (state, action) => {
        state.currentStage = action.payload;
        state.loading = false;
      })
      .addCase(moveToNextStage.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default projectJournalSlice.reducer;
